import { Suspense } from "react";
import { Route, Routes, useNavigate } from "react-router";
import { useTypedParams } from "react-router-typesafe-routes";
import { PageLoading } from "~/components/loading";
import { v2Route } from "~/v2/routes";
import { EntityDetail } from "./components/EntityDetail";
import { EntitiesContainer } from "./components/entities.container";

function EntityDetailRoute() {
  const { id = "" } = useTypedParams(v2Route.entities.detail);
  const navigate = useNavigate();
  return <EntityDetail id={id} onBack={() => navigate("..")} />;
}

export function EntitiesRoutes() {
  return (
    <Suspense fallback={<PageLoading />}>
      <Routes>
        <Route index element={<EntitiesContainer />} />
        <Route path=":id" element={<EntityDetailRoute />} />
      </Routes>
    </Suspense>
  );
}
